window.addEventListener("load", function(){
    let customerPetsData = Array.isArray(window.customerPets || customerPets)
    ? (window.customerPets || customerPets)
    : [];
    if (customerPetsData.length) {
      const data = customerPetsData
      const triggers = {
        feeding: [],
        size: [],
      }
      data.forEach(pet => {
        if (!triggers.feeding.includes(pet.portion_size)) {
          triggers.feeding.push(pet.portion_size)
        }
        

        if (parseInt(pet.pet_weight) <= 25) {
          if (!triggers.size.includes('small')) {
            triggers.size.push('small')
          }
        } else if (parseInt(pet.pet_weight) > 25 && parseInt(pet.pet_weight) < 55) {
          if (!triggers.size.includes('medium')) {
            triggers.size.push('medium')
          }
        } else if (parseInt(pet.pet_weight) >= 55) {
          if (!triggers.size.includes('large')) {
            triggers.size.push('large')
          }
        }
      });

      if (triggers.feeding.length <= 1) {
        document.querySelector(`[data-fmp-feeding="default"]`)?.classList.add('hidden')
        document.querySelector(`[data-fmp-feeding="${triggers.feeding[0]}"]`)?.classList.remove('hidden')
      }

      if (triggers.size.length <= 1) {
        document.querySelector(`[data-fmp-size="default"]`)?.classList.add('hidden')
        document.querySelector(`[data-fmp-size="${triggers.size[0]}"]`)?.classList.remove('hidden')
      }
    }
});
